import { render } from "./FooterMenu.vue?vue&type=template&id=48bb4d78&scoped=true"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=48bb4d78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb4d78"]])

export default __exports__